import { featuredCategories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              Popular Categories
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-md">
              Browse our curated collection across {featuredCategories.length} categories — find exactly what you are looking for
            </p>
          </div>
          <div className="flex gap-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              View All Categories
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {featuredCategories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} - AllChinaBuy Spreadsheet`}
                  title={`${cat.name} Category - AllChinaBuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5">Shop now →</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}